import { useState } from "react";
import { SummaryText } from "../../../utils/resellerPackageUtils";
import { getUserResellerType, ResellerType } from "../../../utils/getUserInformation";
import useLocalStorage from "../../../hooks/useLocalStorage";

const ResellerSummary = ({ userFirstName, userLastName, userEmail, selectedPackages, existingReseller }) => {

	const [parentResellerType, setParentResellerType] = useState(ResellerType.Invalid)

	useLocalStorage("ap-liu", () => {
    setParentResellerType(getUserResellerType());
  });

  function formatGBP(value) {
    const hasDecimals = value % 1 !== 0;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(value);
  }

	return (
		<div>
			{!existingReseller ?
				(<p>
					{SummaryText} The Reseller will be able to assign training to their customers for the packages you have assigned them. You will be invoiced by iTEL 
					for these sales.
				</p>) :
				(<p>
					The Reseller you have named already exists in ucSKILLS Admin Portal. When they next log in they will be prompted to accept or decline your invite to sell
					the training packages you have defined on your behalf. They will show as pending in your list until they have accepted your invite.
				</p>)
			}
			<h4 className="no-margin mb-2">Main Contact</h4>
			<div className="font_s mb-3">{userFirstName.value} {userLastName.value}<br />{userEmail.value}</div>
			<h4 className="no-margin mb-2">Packages</h4>
      <ul className="list-none font_s">
        {selectedPackages.map((record) => {
          const isPCP = !record.PUP;
          const showPrices =
            parentResellerType === ResellerType.Billable ||
            parentResellerType === ResellerType.iTEL;

          const seatText = isPCP
            ? `PCP (${record.SeatBlockSize === 999999 ? "Unlimited" : record.SeatBlockSize} seats per package)`
            : "PUP";

          const priceParts = [];
       
          if (showPrices) {
            if (record.LevelPrice > 0) {
              priceParts.push(`Level: ${formatGBP(record.LevelPrice)}`);
            }
            if (record.OnboardingPrice > 0) {
              priceParts.push(`Onboarding: ${formatGBP(record.OnboardingPrice)}`);
            }
            if (record.Price > 0) {
              priceParts.push(`Price: ${formatGBP(record.Price)}`);
            }
            if (record.UpsellPrice > 0) {
              priceParts.push(`Upsell: ${formatGBP(record.UpsellPrice)}`);
            }

            if (
              !record.LevelName &&
              (record.BronzePrice > 0 ||
                record.SilverPrice > 0 ||
                record.GoldPrice > 0 ||
                record.PlatinumPrice > 0)
            ) {
              if (record.BronzePrice > 0) {
                priceParts.push(`Bronze: ${formatGBP(record.BronzePrice)}`);
              }
              if (record.SilverPrice > 0) {
                priceParts.push(`Silver: ${formatGBP(record.SilverPrice)}`);
              }
              if (record.GoldPrice > 0) {
                priceParts.push(`Gold: ${formatGBP(record.GoldPrice)}`);
              }
              if (record.PlatinumPrice > 0) {
                priceParts.push(`Platinum: ${formatGBP(record.PlatinumPrice)}`);
              }
            }
          }

          return (
            <li key={record.PackageId} className="mb-1">
              <b>{record.Name}</b> — {seatText}
              {priceParts.length > 0 && ` — ${priceParts.join(" | ")}`}
            </li>
          );
        })}
      </ul>

		</div>
	);
};

export default ResellerSummary;